/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ========== ~~~~~~~~~~ SETTINGS : REDUCER ~~~~~~~~~~ ========== */
// REDUCER
// used to manipulate application state
// takes an action, checks its type, based on that performs certain functionality, then returns new slice of state
// utilized in "_container" components

const settings = (state = {}, action) => {
    switch (action.type) {
        default:
            return state;
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default settings;
